var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('String',{staticClass:"string--blue",attrs:{"strLength":this.strLength}},[_c('Blue',{attrs:{"brightness":_vm.channelOneBrightness}}),_c('Blue',{attrs:{"brightness":_vm.channelTwoBrightness}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }